import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_DESPESASGERAIS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterAnexos(despesaId) {
        return axiosJwt
            .get(`${api}/despesasgerais/requisitantes/anexos/pordespesa/${despesaId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexo(despesaAnexoId) {
        return axiosJwt
            .get(`${api}/despesasgerais/requisitantes/anexos/${despesaAnexoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTiposAnexos() {
        return axiosJwt
            .get(`${api}/despesasgerais/requisitantes/anexos/tiposanexos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirAnexo(anexoDto) {
        const formData = new FormData()
        formData.append('anexoTipoId', anexoDto.anexoTipoId)
        formData.append('descricao', anexoDto.descricao)
        formData.append('arquivo', anexoDto.arquivo)
        formData.append('despesaId', anexoDto.despesaId)
        return axiosJwt
            .post(`${api}/despesasgerais/requisitantes/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarAnexo(anexoDto) {
        const formData = new FormData()
        formData.append('anexoTipoId', anexoDto.anexoTipoId)
        formData.append('descricao', anexoDto.descricao)
        formData.append('despesaId', anexoDto.despesaId)
        formData.append('despesaAnexoId', anexoDto.despesaAnexoId)
        return axiosJwt
            .put(`${api}/despesasgerais/requisitantes/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAnexo(anexo) {
        return axiosJwt
            .delete(`${api}/despesasgerais/requisitantes/anexos/${anexo.despesaAnexoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    baixarAnexo(anexo) {
        return axiosJwt
            .get(
                `${api}/despesasgerais/requisitantes/anexos/baixar/${anexo.despesaAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }

}